import { Container, Grid } from '@mui/material';
import MKTypography from 'components/MKTypography';
import DefaultCounterCard from 'examples/Cards/CounterCards/DefaultCounterCard';
import { useEffect, useState } from 'react';

const OurImpact = () => {

  let impactData = [
    {
      id: 1,
      section_count: 19,
      section_suffix: '',
      section_title: 'Supplier Companies',
      section_body: 'Trained and Counting'
    },
    {
      id: 2,
      section_count: 171,
      section_suffix: '+',
      section_title: 'Hours',
      section_body: 'Spent on high-impact training sessions and workshops'
    }
  ]
  

  return (
    <>
      <Container sx={{ textAlign: 'center' }}>
        <MKTypography textGradient variant='h2' mb={3} mt={1}>
          Our Impact
        </MKTypography>
      </Container>
      <Container sx={{ mb: 10 }}>
        <Grid container justifyContent='center' sx={{ textAlign: 'center' }}>
          {impactData.map((impact_data) => {
            return (
              <Grid item xs={12} md={3} key={impact_data.id}>
                <DefaultCounterCard
                  color='error'
                  count={impact_data.section_count}
                  separator=','
                  suffix={impact_data.section_suffix}
                  title={impact_data.section_title}
                  titleColor='warning'
                  description={impact_data.section_body}
                />
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </>
  );
};
export default OurImpact;
